// extracted by mini-css-extract-plugin
export default {"searchInput":"GeoTiffHeader_searchInput__ZoDdC","refreshBtn":"GeoTiffHeader_refreshBtn__tXKmq"};